// @flow
import React from 'react';

type Props = {
  name: string,
};

export const Icon = (props: Props) => {
  const { name } = props;

  let iconName = 'facebook';
  switch (name) {
    case 'twitter':
      iconName = 'twitter';
      break;
    case 'instagram':
      iconName = 'instagram';
      break;
    case 'youtube':
      iconName = 'youtube-play';
      break;
    case 'linkedin':
      iconName = 'linkedin';
      break;
    case 'facebook':
    default:
      break;
  }

  return <i className={`fa fa-${iconName}`} />;
};
